import { render } from "./PairImageText.vue?vue&type=template&id=5cdfa564&scoped=true"
import script from "./PairImageText.vue?vue&type=script&lang=ts"
export * from "./PairImageText.vue?vue&type=script&lang=ts"

import "./PairImageText.vue?vue&type=style&index=0&id=5cdfa564&lang=less&scoped=true"
import "./PairImageText.vue?vue&type=style&index=1&id=5cdfa564&lang=less"
script.render = render
script.__scopeId = "data-v-5cdfa564"

export default script